/**
 * Microsoft sign-in is visible again (Handoff 33). Publisher verification
 * is done on the EcoIntel app registration. Set
 * REACT_APP_SHOW_MICROSOFT_SIGNIN=false only as an emergency hide.
 */
export const SHOW_MICROSOFT_SIGNIN =
  process.env.REACT_APP_SHOW_MICROSOFT_SIGNIN !== 'false';
